module.exports = {
    path: "/platform-insights",
    component: () => import("@/modules/platform-insights/PlatformInsights.vue"),
    meta: { module: "pi" },
    children: [
        {
            name: 'asset-summary',
            path: 'asset-summary',
            alias:'',
            component: () => import('@pi/views/AssetSummary.vue'),
            meta: { module: 'pi' }
        },
        {
            name: 'user-summary',
            path: 'user-summary',
            alias:'',
            component: () => import('@pi/views/UserSummary.vue'),
            meta: { module: 'pi' }
        }
    ]
  };
  


// WEBPACK FOOTER //
// ./src/modules/platform-insights/router.js